import { showLoading, hideLoading } from 'react-redux-loading-bar';

import { infoMessage, successMessage } from './../utils/message';
import { shortString } from './../utils/string';
import locale from '../utils/localization.json';
import {
    deletePanorama,
    getPanorama,
    getPanoramas,
    uploadPanoramas,
} from '../services/PanoService';

export const getAllPanoramas = () => {
    return async (dispatch) => {
        try {
            dispatch(showLoading());

            const { status, data } = await getPanoramas();
            if (status === 200) {
                const panoramas = await Promise.all(
                    data.map(async (pano) => {
                        const { data } = await getPanorama(pano);

                        const { name, lastModified, url } = data.find(
                            ({ name }) => name.includes('jpg')
                        );
                        const { url: json } = data.find(({ name }) =>
                            name.includes('json')
                        );

                        return {
                            name: name.split(/\.(?=[^.]+$)/)[0],
                            type: name.split(/\.(?=[^.]+$)/)[1],
                            date: lastModified,
                            url,
                            json,
                        };
                    })
                );

                await dispatch({
                    type: 'INIT_PANORAMA',
                    payload: panoramas,
                });
            }
        } catch {
        } finally {
            dispatch(hideLoading());
        }
    };
};

export const uploadNewPanoramas = (files, callback) => {
    return async (dispatch, getState) => {
        const lang = getState().language;

        const body = new FormData();

        files.forEach((file) => {
            body.append('files', file);
        });

        try {
            infoMessage(
                `${locale[lang].panoUploading}${'\n'}${locale[lang].uploadStart2}`
            );
            const config = {
                onUploadProgress: callback,
            };

            const { status } = await uploadPanoramas(body, config);

            if (status === 200) {
                successMessage(
                    `${locale[lang].panoUploaded}`
                );
                dispatch(getAllPanoramas());
            }
        } catch {}
    };
};

export const handlePanoramaDelete = (name, type) => {
    return async (dispatch, getState) => {
        const lang = getState().language;
        try {
            const { status } = await deletePanorama(name);

            if (status === 200) {
                successMessage(
                    `"${shortString(`${name}.${type}`, 23)}" ${
                        locale[lang].deleted
                    }`
                );

                dispatch(getAllPanoramas());
            }
        } catch {}
    };
};

export const setCurrentPanorama = (panorama) => {
    return async (dispatch) => {
        await dispatch({ type: 'SET_PANORAMA', payload: panorama });
    };
};
